import { Grid } from "@mui/material";
import { GridItem } from "Components/Shared/GridItem";
import { FormSection } from "Components/Shared/FormSection";
import { UserStatusCell } from "Components/Users/UserListTable/UserStatusCell";
import type { UserStatus } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const FORM_RESOURCES =
  Resources.Pages.Content.UserDetailPageContent.Tabs.User.Form;

type Props = {
  login: string;
  status: UserStatus;
};

export const AccountSection = ({ login, status }: Props) => {
  const { t } = useResource();

  return (
    <FormSection legend={t(FORM_RESOURCES.Legend.Account)} noMargins>
      <Grid container spacing={2}>
        <GridItem columns={2} label={t(FORM_RESOURCES.Login)} value={login} />
        <GridItem
          columns={2}
          label={t(FORM_RESOURCES.Status)}
          value={<UserStatusCell status={status} />}
        />
      </Grid>
    </FormSection>
  );
};
